<template>
  <Modal
    ref="modalRef"
    negativeActionText="Vazgeç"
    positiveActionText="Devam Et"
    :showIcon="false"
    :withCloser="true"
    :clickToClose="true"
    modalStyle="width: 420px;"
    @onNegativeActionClick="handleDismiss"
    @onPositiveActionClick="handleContinue"
    @modalClosed="onModalClosed"
  >
    <template #body>
      <div class="modal-content-wrapper">
        <img
          src="@/assets/images/empty-catalog-table.svg"
          alt="Ürün bulunamadı"
          class="modal-image"
        />
        <h3 class="modal-title">Yeni Varyant Ekle</h3>
        <p class="modal-description">
          Yönlendirileceğiniz sayfadaki bilgileri düzenleyerek varyant ekleyebilirsiniz. Eklediğiniz varyantı ürün detay sayfasında "Ürünün Diğer Seçeneklerini Gör" alanına tıklayarak veya ürün listenizde görebilirsiniz.
        </p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, watch } from "vue";
import { Modal } from "@n11/so-ui-components";
import { sendProductDetailEvent } from "@/utils/ga4/helper";
import { GA4_EVENT } from "@/utils/ga4/event";

const emit = defineEmits(["continue", "close"]);
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
    default: false,
  },
  productData: {
    type: Object,
    default: () => null,
  },
  productId: {
    type: [String, Number],
    required: false,
    default: '',
  },
});

const modalRef = ref();
const isContinuingAction = ref(false);
const isDismissedManually = ref(false);

watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal && modalRef.value) {
      isContinuingAction.value = false;
      isDismissedManually.value = false;
      modalRef.value.openModal();
    } else if (!newVal && modalRef.value) {
      modalRef.value.hiddenModal();
    }
  }
);

const handleDismiss = () => {
  isDismissedManually.value = true;
  if (props.productId) {
    sendProductDetailEvent(GA4_EVENT.ADD_ADDITIONAL_VARIANT_DISMISS, {
      button_name: 'Vazgeç',
      button_type: 'Additional Variant Dismiss',
      button_area: 'Order and Variant Information',
      item_id: String(props.productId || ''),
    });
  }
  emit("close");
};

const onModalClosed = () => {
  if (!isContinuingAction.value && !isDismissedManually.value && props.productId) {
    isDismissedManually.value = true;
    sendProductDetailEvent(GA4_EVENT.ADD_ADDITIONAL_VARIANT_DISMISS, {
      button_name: 'Vazgeç',
      button_type: 'Additional Variant Dismiss',
      button_area: 'Order and Variant Information',
      item_id: String(props.productId || ''),
    });
  }
  emit("close");
};

const handleContinue = () => {
  const existingData = localStorage.getItem('variantTemplateData');

  if (props.productId) {
    sendProductDetailEvent(GA4_EVENT.ADD_ADDITIONAL_VARIANT_SUCCESS, {
      button_name: 'Devam Et',
      button_type: 'Additional Variant Success',
      button_area: 'Order and Variant Information',
      item_id: String(props.productId || ''),
    });
  }

  isContinuingAction.value = true;
  emit("continue");
  emit("close");
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.modal-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
}

.modal-image {
  width: 120px;
  height: auto;
  margin-bottom: 8px;
}

.modal-title {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
}

.modal-description {
  color: $coolGray-70;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 24px;
}
</style>
